<template>
    <div id="participacoes-por-segmento" class="border-gray-400 border bg-white rounded px-6 py-4 shadow-lg h-full">
        <div class="empty" v-if="!(statistics && statistics.length !== 0)">
            <h2 class="text-gray-900 font-bold text-xl mb-2">Demissões por segmento</h2>
            <p class="warning text-gray-700 text-base">Sem informações para exibir</p>
        </div>
        <div v-else class="graphics">
            <apexchart type="bar" :options="chartOptions" :series="chartData"></apexchart>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            statistics: {
                type: Array,
                required: true
            }
        },
        watch: {
            statistics(newVal) {
                this.chartOptions.xaxis.categories = newVal?.map(statistic => statistic.label)
                this.chartData[0].data = newVal?.map(statistic => statistic.value)
            }
        },
        data() {
            return {
                chartData: [{
                    name: 'Número de demissões',
                    data: this.statistics?.map(statistic => statistic.value)
                }],
                chartOptions: {
                    responsive: [
                        {
                            breakpoint: 1000,
                            options: {
                                chart: {
                                    height: 450
                                }
                            }
                        }
                    ],
                    dataLabels: {
                        enabled: true
                    },
                    chart: {
                        toolbar: {
                            show: false,
                        },
                    },
                    title: {
                        text: 'Demissões por segmento',
                        style: {
                            fontSize: '20px'
                        }
                    },
                    plotOptions: {
                        bar: {
                            distributed: true,
                            dataLabels: {
                                position: 'bottom'
                            }
                        }
                    },
                    xaxis: {
                        categories: this.statistics?.map(statistic => statistic.label),
                        labels: {
                            show: false
                        }
                    }
                },
            }
        }
    }
</script>